import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEnvase } from "../hooks/useEnvase";

export const CultivoForm = ({
  values,
  errors,
  touched,
  loading,
  handleChange,
  setFieldValue,
  handleSubmit,
  isEditing,
  onCancel,
}) => {
  const { envase } = useEnvase();

  const handleChangeEnvase = (e, id_envase) => {
    let id_envase_list = [...values.envases];
    const checked = e.target.checked;

    if (checked && !id_envase_list.includes(id_envase)) {
      id_envase_list.push(id_envase);
    } else {
      id_envase_list = id_envase_list.filter((item) => item !== id_envase);
    }

    setFieldValue("envases", id_envase_list);
  };

  const handleSelecAll = (e) => {
    const checked = e.target.checked;
    if (checked) {
      setFieldValue(
        "envases",
        envase.map((item) => item.idtamano_envase)
      );
    } else {
      setFieldValue("envases", []);
    }
  };

  return (
    <div style={{ flex: 1 }}>
      <label style={{ width: "100%" }}>
        <label>Cultivo</label>
        <input
          className="form-control"
          placeholder="Cultivo"
          value={values.cultivo}
          onChange={handleChange}
          name="cultivo"
          style={
            (errors.cultivo && touched.cultivo) !== undefined
              ? {
                  borderColor: "red",
                }
              : {}
          }
        />
      </label>
      <br />
      <br />
      <div className="table-responsive" style={{ maxHeight: "400px" }}>
        <table className="table">
          <thead>
            <tr>
              <th>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    onChange={handleSelecAll}
                  />
                </div>
              </th>
              <th>ENVASE</th>
            </tr>
          </thead>
          <tbody>
            {envase.map((item) => (
              <tr key={item.idtamano_envase}>
                <td>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      onChange={(e) =>
                        handleChangeEnvase(e, item.idtamano_envase)
                      }
                      checked={values.envases?.includes(item.idtamano_envase)}
                    />
                  </div>
                </td>
                <td>{item.tamano}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="d-grid">
        <button
          className="btn btn-success"
          onClick={handleSubmit}
          type="submit"
          disabled={loading}
        >
          {loading && <FontAwesomeIcon icon="fas fa-spinner" spin />} Agregar
        </button>
        <br />
        {isEditing && (
          <button
            className="btn btn-outline-danger"
            onClick={onCancel}
            type="button"
          >
            Cancelar
          </button>
        )}
      </div>
    </div>
  );
};
